export default "__VITE_ASSET__BoVYoSlu__"